import { Component, forwardRef, Inject, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { RateLookupResult } from '@assetaccountant/core/services/depreciation.service';
import { setupModal, TypedNgbModal } from '@assetaccountant/core/utils/typed-modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { DepreciationLookupModalComponent } from '../depreciation-lookup-modal/depreciation-lookup-modal.component';

@Component({
  selector: 'app-depreciation-lookup',
  templateUrl: './depreciation-lookup.component.html',
  styleUrls: ['./depreciation-lookup.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DepreciationLookupComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class DepreciationLookupComponent implements ControlValueAccessor {
  @Input() regimeId: number;
  @Input() lifeIsEditable: boolean;
  @Input() lifeValues?: number[] | null;

  readonly RegisterPermission = RegisterPermissionType;

  value: RateLookupResult | null = null;

  _onChange?: (value: RateLookupResult | null) => void;
  _onTouched?: () => void;

  get isApplicable() {
    switch (this.regimeId) {
      case 1: // AU Tax
      case 3: // NZ Tax
      case 100: // US Tax
        return this.lifeIsEditable && (this.lifeValues == null || this.lifeValues.length > 2);
      default:
        return false;
    }
  }

  constructor(@Inject(NgbModal) private ngbModal: TypedNgbModal) {}

  openSearch() {
    const modalRef = setupModal(
      this.ngbModal.open(DepreciationLookupModalComponent, { size: 'lg' }),
      modal => {
        modal.regimeId = this.regimeId;
      },
      modal => [
        modal.selectRate.subscribe(x => {
          this.value = x;
          this._onChange?.(x);
        }),
      ],
    );

    modalRef.result.then(
      () => this._onTouched?.(),
      () => this._onTouched?.(),
    );
  }

  clear() {
    this.value = null;
    this._onChange?.(null);
    this._onTouched?.();
  }

  registerOnChange(fn: (value: RateLookupResult | null) => void) {
    this._onChange = fn;
  }
  registerOnTouched(fn: () => void) {
    this._onTouched = fn;
  }

  writeValue(value: RateLookupResult | null) {
    this.value = value;
  }
}
